import Chart3ie from "../../../../src/client/3ieimpact/chart3ie.json";
import Chart3ieSchematic from "../../../../src/client/3ieimpact/interactions/schematic/Chart";
import * as React from 'react';
export default {
  Chart3ie,
  Chart3ieSchematic,
  React
};